import React from "react";
import {
    Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay
} from "@chakra-ui/react";

function OptionsPanel({isOpen, onClose, questions,setOption,sendingOptions}) {
    return (<Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
            <ModalHeader>کلید من</ModalHeader>
            <ModalCloseButton/>
            <ModalBody>
                <ul className="modal-options nazanin">
                {questions.map((question, index) => (
                              <li key={index} className="d-flex flex-row justify-content-center align-items-center">
                            <h4>سوال {index+1} : </h4>
                            {question.options.map((option, option_index) => (
                                                            <span key={option_index} className={`option counter ${
                                                                option_index === question.selected_option ? "selected" : ""
                                                            } ${
                                                                sendingOptions[index] === option_index ? "sending" : ""
                                                            }`} onClick={() => {
                                                                setOption(index,option_index)
                                                            }}>
                                                            <div>
                                                            {option_index+1}
                                                            </div>
                                                        </span>
                    ))}
                        </li>
                ))}
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                    بستن
                </Button>
            </ModalFooter>
        </ModalContent>
</Modal>
)
    ;
}

export default OptionsPanel;